const firstMonthCoupons = {
  '15_off'              : 'HDR15',
  '20_off'              : 'HDR20',
  '25_off'              : 'HD25',
  '30_off'              : '30HDR',
  '50_off'              : 'HHDDR50',
  surkus30              : 'SURKUS30',
  off30Influencer       : 'HDR30INF',
  freeTrial             : 'FREE_TRIAL',
  '2items70'            : '2ITEMS70',
  '2items25'            : '2ITEMS25',
  '3items25'            : '3ITEMS25',
  tophatter2            : 'TOPHATTER001',
  tophatter3            : 'TOPHATTER3',
  flexmg                : 'FLEXMG',
}

const discountCoupons = {
  ...firstMonthCoupons,
  fivemonthdiscount     : 'SUBFOR13505MONTHS',
}


export {
  discountCoupons,
  firstMonthCoupons,
}
